/** fetches a json, defaults to mock.json */
module.exports = function fetchJSON(source = 'mock') {
	// eslint-disable-next-line
	return JSON.stringify(require(`${__dirname}/../../etc/${source}.json`)) || '{}';
};
